import { Injectable } from '@angular/core';
import { EnviromentContextService } from './enviroment-context-service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class BasicEnviromentContextService extends EnviromentContextService {
  
  private enviromentSubject = new BehaviorSubject<string | null>(null);
  private companySubject = new BehaviorSubject<string | null>(null);
  private packingStationSubject = new BehaviorSubject<string | null>(null);
  private requestWeightSubject = new BehaviorSubject<boolean>(false);
  private videoSubject = new BehaviorSubject<boolean>(true);
  private videoLengthSubject = new BehaviorSubject<number>(0);
  private diffVersionSubject = new BehaviorSubject<boolean>(false);
  private integratedSubject = new BehaviorSubject<boolean>(false);

  constructor() {
    super();
  }

  public get enviroment(): Observable<string | null> {
    return this.enviromentSubject.asObservable();
  }

  public get company(): Observable<string | null> {
    return this.companySubject.asObservable();
  }

  public get packingStation(): Observable<string | null> {
    return this.packingStationSubject.asObservable();
  }

  public get requestWeight(): Observable<boolean> {
    return this.requestWeightSubject.asObservable();
  }

  public getCompany(): string | null {
    return this.companySubject.getValue();
  }

  public getEnviroment(): string | null {
    return this.enviromentSubject.getValue();
  }

  public setEnviroment(name: string) {
    this.enviromentSubject.next(name);
  }

  public setCompany(name: string) {
    this.companySubject.next(name);
  }

  public setPackingStation(name: string) {
    this.packingStationSubject.next(name);
  }

  public setRequestWeight(requestWeight: boolean): void {
    this.requestWeightSubject.next(requestWeight);
  }
  public getRequestWeight(): boolean {
    return this.requestWeightSubject.getValue();
  }

  public get video(): Observable<boolean> {
    return this.videoSubject.asObservable();
  }

  public get videoLength(): Observable<number> {
    return this.videoLengthSubject.asObservable();
  }

  public get diffVersion(): Observable<boolean> {
    return this.diffVersionSubject.asObservable();
  }

  public get integrated(): Observable<boolean> {
    return this.integratedSubject.asObservable();
  }

  public setVideo(video: boolean): void {
    this.videoSubject.next(video);
  }

  public getVideo(): boolean {
    return this.videoSubject.getValue();
  }

  public setVideoLength(videoLength: number): void {
    this.videoLengthSubject.next(videoLength);
  }

  public getVideoLength(): number {
    return this.videoLengthSubject.getValue();
  }

  public setDiffVersion(version: boolean): void {
    this.diffVersionSubject.next(version);
  }

  public getDiffVersion(): boolean {
    return this.diffVersionSubject.getValue();
  }

  public setIntegrated(integrated: boolean): void {
    this.integratedSubject.next(integrated);
  }

  public getIntegrated(): boolean {
    return this.integratedSubject.getValue();
  }

}
